import React from 'react';
import {
  CheckWithEllipseIcon,
  LineIcon,
  ProcessWithEllipseIcon,
} from '@dynamika-shared/ui/icons';
import { TimelineSectionRowProps } from './common/types';

export const TimelineSectionRow: React.FC<TimelineSectionRowProps> = ({
  children,
  topOffsetPx = 20,
  dotClassName = 'h-3.5 w-3.5 rounded-full text-white',
  dateLabel,
  visitStatus,
}) => {
  const DotIcon =
    visitStatus === 'CLOSED' ? CheckWithEllipseIcon : ProcessWithEllipseIcon;

  return (
    <div className='flex pt-2 items-stretch gap-3'>
      <div className='flex flex-col items-end justify-start pt-1 w-[110px] font-semibold leading-tight'>
        {dateLabel && (
          <span className='text-primary-light text-[14px] pt-[5px]'>
            {dateLabel}
          </span>
        )}
      </div>

      <div className='shrink-0 pt-1 flex flex-col items-center'>
        <DotIcon className={dotClassName} />

        <div
          className='flex-1 flex overflow-hidden'
          style={{ marginTop: topOffsetPx }}
        >
          <LineIcon className='block w-[2px] h-full' />
        </div>
      </div>

      <div className='flex-1 min-w-0'>{children}</div>
    </div>
  );
};
